export enum ChatType {
  DEEP_RESEARCH = 'DEEP_RESEARCH',
}
